<div class="modal-header">
    <div class="modal-heading">{{ 'flipto.account.PhotoReplacement' | translate }}</div>
</div>
<div class="imageLibrary-content" #dzRoot>
    <div class="dropzone dz-message" style="text-align: center;">
        <div class="instructions">
            {{ 'flipto.account.components.imageLibrary.ImageUploadMessage' | translate }}
        </div>
    </div>
    <div class="error" [style.display]="uploadFailed() ? null : 'none'">
        {{ 'flipto.account.components.imageLibrary.ImageUploadErrorMessage' | translate }}
    </div>
</div>
